module.exports = __webpack_public_path__ + "static/media/0.be2b5342.png";